import { render } from "./add-subscription-plan.vue?vue&type=template&id=4f9c3302"
import script from "./add-subscription-plan.vue?vue&type=script&lang=js"
export * from "./add-subscription-plan.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroAdmin\\marriage_beauro_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__